/*
 * @Author: guodm guodm@9856
 * @Date: 2023-08-08 15:56:29
 * @LastEditors: guodm guodm@9856
 * @LastEditTime: 2023-08-22 17:32:02
 * @FilePath: \website\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios";
import md5 from 'js-md5';
function signatureFun() {
    let str = "abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let Atxt = "";
    let timego = "";
    for (let i = 0; i < 16; i++) {
        Atxt += str.charAt(Math.floor(Math.random() * str.length));
    }
    timego = Math.round(new Date() / 1000);
    let signtxt = "";
    signtxt = md5("OJBkna14KGPAHCI9" + Atxt + timego)
    return {
        Atxt,
        timego,
        signtxt
    }
}
// axios 实例
const service = axios.create({
    // baseURL: "http://116.204.89.85:8012",
    baseURL: "https://api.jiutoubiao.com",
    timeout: 60000,
});
// axios 请求拦截
service.interceptors.request.use(
  config => {
    let signature = signatureFun();
    config.headers.noncestr = signature.Atxt;  // 或者 Atxt
    config.headers.timestamp = signature.timego; // 或者 timego
    config.headers.sign = signature.signtxt;           // 或者 signtxt
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// axios 响应拦截
service.interceptors.response.use(
  response => {

    return response.data;
  },
  error => {

    if (!error.response?.data) {
      return {
        code: -222,
        msg: "网络连接失败！"
      };
    }
    return Promise.reject(error);
  }
);

export default service;
